var map = {
	"./visa1.jpeg": 4029,
	"./visa10.jpeg": 4963,
	"./visa11.jpeg": 2684,
	"./visa12.jpeg": 5565,
	"./visa13.jpeg": 2342,
	"./visa2.jpeg": 6364,
	"./visa3.jpeg": 3299,
	"./visa4.jpeg": 7298,
	"./visa5.jpeg": 3977,
	"./visa6.jpeg": 6296,
	"./visa7.jpeg": 4815,
	"./visa8.jpeg": 9278,
	"./visa9.jpeg": 7557
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7755;